//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return OK
 */
export function abpTenantFindTenantByName(name: string, config?: AxiosRequestConfig | undefined): Promise<Types.FindTenantResultDto> {
    let url_ = getBaseUrl() + "/api/abp/multi-tenancy/tenants/by-name/{name}";
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAbpTenantFindTenantByName,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAbpTenantFindTenantByName?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAbpTenantFindTenantByName(_response);
    });
}

function processAbpTenantFindTenantByName(response: AxiosResponse): Promise<Types.FindTenantResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.FindTenantResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FindTenantResultDto>(null as any);
}

/**
 * @return OK
 */
export function abpTenantFindTenantById(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.FindTenantResultDto> {
    let url_ = getBaseUrl() + "/api/abp/multi-tenancy/tenants/by-id/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAbpTenantFindTenantById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAbpTenantFindTenantById?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAbpTenantFindTenantById(_response);
    });
}

function processAbpTenantFindTenantById(response: AxiosResponse): Promise<Types.FindTenantResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.FindTenantResultDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FindTenantResultDto>(null as any);
}
let _requestConfigAbpTenantFindTenantByName: Partial<AxiosRequestConfig> | null;
export function getAbpTenantFindTenantByNameRequestConfig() {
  return _requestConfigAbpTenantFindTenantByName;
}
export function setAbpTenantFindTenantByNameRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAbpTenantFindTenantByName = value;
}
export function patchAbpTenantFindTenantByNameRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAbpTenantFindTenantByName = patch(_requestConfigAbpTenantFindTenantByName ?? {});
}

let _requestConfigAbpTenantFindTenantById: Partial<AxiosRequestConfig> | null;
export function getAbpTenantFindTenantByIdRequestConfig() {
  return _requestConfigAbpTenantFindTenantById;
}
export function setAbpTenantFindTenantByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAbpTenantFindTenantById = value;
}
export function patchAbpTenantFindTenantByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAbpTenantFindTenantById = patch(_requestConfigAbpTenantFindTenantById ?? {});
}